export { default as Tag, type TagProps } from './Tag';
